'use client';
import { SessionContext } from '@benzinga/session-context';
import { SubscribableEventType } from '@benzinga/subscribable';
import { HoldingsQuote, QuoteHoldingsFeed, QuoteHoldingsManager } from '@benzinga/quote-holdings-manager';
import React from 'react';
import { useActiveWorkspaceSubscriber } from '@benzinga/pro-tools';
import { StockSymbol } from '@benzinga/session';

export const useQuoteHoldingsSubscription = (symbols: StockSymbol[], subscribeToQuotes = true) => {
  const [quotes, setQuotes] = React.useState<HoldingsQuote[]>([]);
  useQuoteHoldingsSubscriptionCallback(symbols, setQuotes, subscribeToQuotes);
  return quotes;
};

export const useQuoteHoldingsSubscriptionCallback = (
  symbols: StockSymbol[],
  callback: (quote: HoldingsQuote[]) => void,
  subscribeToQuotes = true,
) => {
  const session = React.useContext(SessionContext);
  const quoteHoldingManager = React.useMemo(() => session.getManager(QuoteHoldingsManager), [session]);

  const feed = React.useMemo(() => {
    const feed = quoteHoldingManager.createQuotesFeed(symbols, subscribeToQuotes);
    callback(feed.getCachedValue());
    return feed;
  }, [callback, quoteHoldingManager, subscribeToQuotes, symbols]);

  useActiveWorkspaceSubscriber(feed, (event: SubscribableEventType<QuoteHoldingsFeed>) => {
    switch (event.type) {
      case 'quote-holdings:quote-update':
      case 'quote-holdings:update':
        callback(feed.getCachedValue());
        break;
    }
  });
};
